import React from "react";
import Footer from "../../components/Footer/Footer";

import TopMenu from "../../components/Navbar/Navbar";

// document.addEventListener("DOMContentLoaded", function () {
//   window.addEventListener("scroll", function () {
//     let navbar_height = document.getElementById("c-top-navbar").offsetHeight;
//     let openMenu = this.document.getElementById("navbarScroll");
//     openMenu.classList.remove("show");
//     if (window.scrollY > navbar_height + 50) {
//       document.getElementById("c-top-navbar").classList.add("fixed-top");
//       document.getElementById("c-nav-bar-fixer").style.height =
//         navbar_height + "px";
//     } else {
//       document.getElementById("c-top-navbar").classList.remove("fixed-top");
//       document.getElementById("c-nav-bar-fixer").style.height = "auto";
//     }
//   });
// });

const BaseLayout = (props) => {
  return (
    <div className="d-flex flex-column justify-content-between">
      <main id="wrapper">
        <div className="c-top-section">
          <TopMenu background="white" />
        </div>
        <div>{props.children}</div>
        <Footer />
      </main>
    </div>
  );
};

export default BaseLayout;
